import { SolAuthority } from '@sol/components';

export class AsmAuthority {
  // Release features, synthesized from `/authorities` features by SessionService.calculateAuthorities
  public static readonly FEATURE_BILLING: SolAuthority = 'FEATURE_BILLING';
  public static readonly FEATURE_PARTNER_API: SolAuthority = 'FEATURE_PARTNER_API';
  public static readonly FEATURE_SMOKE_TESTS: SolAuthority = 'FEATURE_SMOKE_TESTS';
  public static readonly FEATURE_THREAT_EXPLORER: SolAuthority = 'FEATURE_THREAT_EXPLORER';
  public static readonly FEATURE_WEB_CONTENT_V3: SolAuthority = 'FEATURE_WEB_CONTENT_V3';

  // Modules (enabled)
  public static readonly MODULE_CREDENTIALS: SolAuthority = 'MODULE_CREDENTIALS';
  public static readonly MODULE_DARK_WEB: SolAuthority = 'MODULE_DARK_WEB';
  public static readonly MODULE_DATA_LEAKAGE: SolAuthority = 'MODULE_DATA_LEAKAGE';
  public static readonly MODULE_EASM: SolAuthority = 'MODULE_EASM';
  public static readonly MODULE_MOBILE: SolAuthority = 'MODULE_MOBILE';
  public static readonly MODULE_OUTSCAN: SolAuthority = 'MODULE_OUTSCAN';
  public static readonly MODULE_SOCIAL_MEDIA: SolAuthority = 'MODULE_SOCIAL_MEDIA';
  public static readonly MODULE_ACCOUNT_TAKEOVER_PREVENTION: SolAuthority = 'MODULE_ACCOUNT_TAKEOVER_PREVENTION';

  //
  // Global
  //
  public static readonly VIEW_DEBUG: SolAuthority = 'VIEW_DEBUG';

  //
  // Platform
  public static readonly VIEW_PLATFORM_APP: SolAuthority = 'VIEW_PLATFORM_APP';
  //
  public static readonly ADD_ANNOTATION_DARK_WEB: SolAuthority = 'ADD_ANNOTATION_DARK_WEB';
  public static readonly ADD_ANNOTATION_DATA_LEAKAGE: SolAuthority = 'ADD_ANNOTATION_DATA_LEAKAGE';
  public static readonly ADD_ANNOTATION_DOMAINS: SolAuthority = 'ADD_ANNOTATION_DOMAINS';
  public static readonly ADD_ANNOTATION_DOMAIN_IDENTIFICATION: SolAuthority = 'ADD_ANNOTATION_DOMAIN_IDENTIFICATION';
  public static readonly ADD_ANNOTATION_HOSTS: SolAuthority = 'ADD_ANNOTATION_HOSTS';
  public static readonly ADD_ANNOTATION_LEAKED_CREDENTIALS: SolAuthority = 'ADD_ANNOTATION_LEAKED_CREDENTIALS';
  public static readonly ADD_ANNOTATION_MOBILE: SolAuthority = 'ADD_ANNOTATION_MOBILE';
  public static readonly ADD_ANNOTATION_SOCIAL_MEDIA: SolAuthority = 'ADD_ANNOTATION_SOCIAL_MEDIA';
  public static readonly ADD_ANNOTATION_TRACKER: SolAuthority = 'ADD_ANNOTATION_TRACKER';
  public static readonly ADD_ANNOTATION_WEBSITES: SolAuthority = 'ADD_ANNOTATION_WEBSITES';
  public static readonly ADD_HOST_MANUALLY: SolAuthority = 'ADD_HOST_MANUALLY';
  public static readonly ADD_INTEGRATION: SolAuthority = 'ADD_INTEGRATION';
  public static readonly ADD_NOTIFICATION_RULES: SolAuthority = 'ADD_NOTIFICATION_RULES';
  public static readonly ADD_OBSERVATION_COMMENT: SolAuthority = 'ADD_OBSERVATION_COMMENT';
  public static readonly ADD_SEED: SolAuthority = 'ADD_SEED';
  public static readonly ADD_SUBSCOPES: SolAuthority = 'ADD_SUBSCOPES';
  public static readonly ADD_TAGS: SolAuthority = 'ADD_TAGS';
  public static readonly ADD_TAG_DARK_WEB: SolAuthority = 'ADD_TAG_DARK_WEB';
  public static readonly ADD_TAG_DATA_LEAKAGE: SolAuthority = 'ADD_TAG_DATA_LEAKAGE';
  public static readonly ADD_TAG_DOMAINS: SolAuthority = 'ADD_TAG_DOMAINS';
  public static readonly ADD_TAG_DOMAIN_IDENTIFICATION: SolAuthority = 'ADD_TAG_DOMAIN_IDENTIFICATION';
  public static readonly ADD_TAG_HOSTS: SolAuthority = 'ADD_TAG_HOSTS';
  public static readonly ADD_TAG_LEAKED_CREDENTIALS: SolAuthority = 'ADD_TAG_LEAKED_CREDENTIALS';
  public static readonly ADD_TAG_MOBILE: SolAuthority = 'ADD_TAG_MOBILE';
  public static readonly ADD_TAG_SOCIAL_MEDIA: SolAuthority = 'ADD_TAG_SOCIAL_MEDIA';
  public static readonly ADD_TAG_TRACKER: SolAuthority = 'ADD_TAG_TRACKER';
  public static readonly ADD_TAG_WEBSITES: SolAuthority = 'ADD_TAG_WEBSITES';
  public static readonly ADD_TO_PRIMARY_DOMAINS_FROM_DOMAIN_IDENTIFICATION: SolAuthority =
    'ADD_TO_PRIMARY_DOMAINS_FROM_DOMAIN_IDENTIFICATION';
  public static readonly API_ACCESS: SolAuthority = 'API_ACCESS';
  public static readonly CANDIDATE_FROM_DOMAIN_IDENTIFICATION: SolAuthority = 'CANDIDATE_FROM_DOMAIN_IDENTIFICATION';
  public static readonly CAN_ACCESS_ADMIN_PANEL: SolAuthority = 'CAN_ACCESS_ADMIN_PANEL';
  public static readonly CAN_ACCESS_KEYCLOAK: SolAuthority = 'CAN_ACCESS_KEYCLOAK';
  public static readonly CAN_ACCESS_LIGHT: SolAuthority = 'CAN_ACCESS_LIGHT';
  public static readonly CAN_CREATE_ADMIN_ONLY_NOTIFICATIONS: SolAuthority = 'CAN_CREATE_ADMIN_ONLY_NOTIFICATIONS';
  public static readonly CAN_SEND_LOGIN_INSTRUCTIONS: SolAuthority = 'CAN_SEND_LOGIN_INSTRUCTIONS';
  public static readonly CAN_SUBSCRIBE_USER_TO_NEWSLETTER: SolAuthority = 'CAN_SUBSCRIBE_USER_TO_NEWSLETTER';
  public static readonly CAN_TOGGLE_ADMIN_FEATURES: SolAuthority = 'CAN_TOGGLE_ADMIN_FEATURES';
  public static readonly CAN_VIEW_ACCESS_CONTROL: SolAuthority = 'CAN_VIEW_ACCESS_CONTROL';
  public static readonly CAN_VIEW_ALL_SCOPES: SolAuthority = 'CAN_VIEW_ALL_SCOPES';
  public static readonly CAN_VIEW_FEATURE_FLAGS: SolAuthority = 'CAN_VIEW_FEATURE_FLAGS';
  public static readonly CAN_VIEW_VERSION: SolAuthority = 'CAN_VIEW_VERSION';
  public static readonly CHANGE_STATUS_DARK_WEB: SolAuthority = 'CHANGE_STATUS_DARK_WEB';
  public static readonly CHANGE_STATUS_DATA_LEAKAGE: SolAuthority = 'CHANGE_STATUS_DATA_LEAKAGE';
  public static readonly CHANGE_STATUS_MOBILE: SolAuthority = 'CHANGE_STATUS_MOBILE';
  public static readonly CHANGE_STATUS_SOCIAL_MEDIA: SolAuthority = 'CHANGE_STATUS_SOCIAL_MEDIA';
  public static readonly CREATE_AUTOMATION_RULES: SolAuthority = 'CREATE_AUTOMATION_RULES';
  public static readonly CREATE_OBSERVATIONS_EXTERNAL_SHARE_LINK: SolAuthority =
    'CREATE_OBSERVATIONS_EXTERNAL_SHARE_LINK';
  public static readonly CREATE_ROLES: SolAuthority = 'CREATE_ROLES';
  public static readonly CREATE_USERS: SolAuthority = 'CREATE_USERS';
  public static readonly DELETE_ANNOTATION_DARK_WEB: SolAuthority = 'DELETE_ANNOTATION_DARK_WEB';
  public static readonly DELETE_ANNOTATION_DATA_LEAKAGE: SolAuthority = 'DELETE_ANNOTATION_DATA_LEAKAGE';
  public static readonly DELETE_ANNOTATION_DOMAINS: SolAuthority = 'DELETE_ANNOTATION_DOMAINS';
  public static readonly DELETE_ANNOTATION_DOMAIN_IDENTIFICATION: SolAuthority =
    'DELETE_ANNOTATION_DOMAIN_IDENTIFICATION';
  public static readonly DELETE_ANNOTATION_HOSTS: SolAuthority = 'DELETE_ANNOTATION_HOSTS';
  public static readonly DELETE_ANNOTATION_LEAKED_CREDENTIALS: SolAuthority = 'DELETE_ANNOTATION_LEAKED_CREDENTIALS';
  public static readonly DELETE_ANNOTATION_MOBILE: SolAuthority = 'DELETE_ANNOTATION_MOBILE';
  public static readonly DELETE_ANNOTATION_SOCIAL_MEDIA: SolAuthority = 'DELETE_ANNOTATION_SOCIAL_MEDIA';
  public static readonly DELETE_ANNOTATION_TRACKER: SolAuthority = 'DELETE_ANNOTATION_TRACKER';
  public static readonly DELETE_ANNOTATION_WEBSITES: SolAuthority = 'DELETE_ANNOTATION_WEBSITES';
  public static readonly DELETE_AUTOMATION_RULES: SolAuthority = 'DELETE_AUTOMATION_RULES';
  public static readonly DELETE_DARK_WEB: SolAuthority = 'DELETE_DARK_WEB';
  public static readonly DELETE_DATA_LEAKAGE: SolAuthority = 'DELETE_DATA_LEAKAGE';
  public static readonly DELETE_INTEGRATION: SolAuthority = 'DELETE_INTEGRATION';
  public static readonly DELETE_MOBILE: SolAuthority = 'DELETE_MOBILE';
  public static readonly DELETE_NOTIFICATION_RULES: SolAuthority = 'DELETE_NOTIFICATION_RULES';
  public static readonly DELETE_OBSERVATIONS_EXTERNAL_SHARE_LINK: SolAuthority =
    'DELETE_OBSERVATIONS_EXTERNAL_SHARE_LINK';
  public static readonly DELETE_ROLES: SolAuthority = 'DELETE_ROLES';
  public static readonly DELETE_SCOPE_REPORTS: SolAuthority = 'DELETE_SCOPE_REPORTS';
  public static readonly DELETE_SEED: SolAuthority = 'DELETE_SEED';
  public static readonly DELETE_SEED_FROM_SCOPE: SolAuthority = 'DELETE_SEED_FROM_SCOPE';
  public static readonly DELETE_SOCIAL_MEDIA: SolAuthority = 'DELETE_SOCIAL_MEDIA';
  public static readonly DELETE_SUBSCOPES: SolAuthority = 'DELETE_SUBSCOPES';
  public static readonly DELETE_TAGS: SolAuthority = 'DELETE_TAGS';
  public static readonly DELETE_TAG_DARK_WEB: SolAuthority = 'DELETE_TAG_DARK_WEB';
  public static readonly DELETE_TAG_DATA_LEAKAGE: SolAuthority = 'DELETE_TAG_DATA_LEAKAGE';
  public static readonly DELETE_TAG_DOMAINS: SolAuthority = 'DELETE_TAG_DOMAINS';
  public static readonly DELETE_TAG_DOMAIN_IDENTIFICATION: SolAuthority = 'DELETE_TAG_DOMAIN_IDENTIFICATION';
  public static readonly DELETE_TAG_HOSTS: SolAuthority = 'DELETE_TAG_HOSTS';
  public static readonly DELETE_TAG_LEAKED_CREDENTIALS: SolAuthority = 'DELETE_TAG_LEAKED_CREDENTIALS';
  public static readonly DELETE_TAG_MOBILE: SolAuthority = 'DELETE_TAG_MOBILE';
  public static readonly DELETE_TAG_SOCIAL_MEDIA: SolAuthority = 'DELETE_TAG_SOCIAL_MEDIA';
  public static readonly DELETE_TAG_TRACKER: SolAuthority = 'DELETE_TAG_TRACKER';
  public static readonly DELETE_TAG_WEBSITES: SolAuthority = 'DELETE_TAG_WEBSITES';
  public static readonly DISABLE_SEED: SolAuthority = 'DISABLE_SEED';
  public static readonly DISMISS_DARK_WEB: SolAuthority = 'DISMISS_DARK_WEB';
  public static readonly DISMISS_DATA_LEAKAGE: SolAuthority = 'DISMISS_DATA_LEAKAGE';
  public static readonly DISMISS_DOMAINS: SolAuthority = 'DISMISS_DOMAINS';
  public static readonly DISMISS_FROM_DOMAIN_IDENTIFICATION: SolAuthority = 'DISMISS_FROM_DOMAIN_IDENTIFICATION';
  public static readonly DISMISS_HOSTS: SolAuthority = 'DISMISS_HOSTS';
  public static readonly DISMISS_LEAKED_CREDENTIAL: SolAuthority = 'DISMISS_LEAKED_CREDENTIAL';
  public static readonly DISMISS_MOBILE: SolAuthority = 'DISMISS_MOBILE';
  public static readonly DISMISS_SOCIAL_MEDIA: SolAuthority = 'DISMISS_SOCIAL_MEDIA';
  public static readonly DISMISS_TRACKER: SolAuthority = 'DISMISS_TRACKER';
  public static readonly DISMISS_WEBSITES: SolAuthority = 'DISMISS_WEBSITES';
  public static readonly EDIT_AUTOMATION_RULES: SolAuthority = 'EDIT_AUTOMATION_RULES';
  public static readonly EDIT_NOTIFICATION_RULES: SolAuthority = 'EDIT_NOTIFICATION_RULES';
  public static readonly EDIT_ROLES: SolAuthority = 'EDIT_ROLES';
  public static readonly EDIT_DASHBOARDS: SolAuthority = 'EDIT_DASHBOARDS';
  public static readonly EDIT_SAVED_SEARCHES: SolAuthority = 'EDIT_SAVED_SEARCHES';
  public static readonly EDIT_SEED: SolAuthority = 'EDIT_SEED';
  public static readonly EDIT_SUBSCOPES: SolAuthority = 'EDIT_SUBSCOPES';
  public static readonly EDIT_TAGS: SolAuthority = 'EDIT_TAGS';
  public static readonly EDIT_USERS: SolAuthority = 'EDIT_USERS';
  public static readonly EDIT_USER_ROLES: SolAuthority = 'EDIT_USER_ROLES';
  public static readonly EXPORT_AUDIT_LOGS: SolAuthority = 'EXPORT_AUDIT_LOGS';
  public static readonly EXPORT_CERTIFICATES: SolAuthority = 'EXPORT_CERTIFICATES';
  public static readonly EXPORT_DARK_WEB: SolAuthority = 'EXPORT_DARK_WEB';
  public static readonly EXPORT_DATA_LEAKAGE: SolAuthority = 'EXPORT_DATA_LEAKAGE';
  public static readonly EXPORT_DOMAINS: SolAuthority = 'EXPORT_DOMAINS';
  public static readonly EXPORT_DOMAINS_IP_MAP: SolAuthority = 'EXPORT_DOMAINS_IP_MAP';
  public static readonly EXPORT_DOMAINS_TECHNOLOGIES: SolAuthority = 'EXPORT_DOMAINS_TECHNOLOGIES';
  public static readonly EXPORT_DOMAINS_WHOIS: SolAuthority = 'EXPORT_DOMAINS_WHOIS';
  public static readonly EXPORT_DOMAIN_IDENTIFICATION: SolAuthority = 'EXPORT_DOMAIN_IDENTIFICATION';
  public static readonly EXPORT_HOSTS: SolAuthority = 'EXPORT_HOSTS';
  public static readonly EXPORT_LEAKED_CREDENTIALS: SolAuthority = 'EXPORT_LEAKED_CREDENTIALS';
  public static readonly EXPORT_MOBILE: SolAuthority = 'EXPORT_MOBILE';
  public static readonly EXPORT_SOCIAL_MEDIA: SolAuthority = 'EXPORT_SOCIAL_MEDIA';
  public static readonly EXPORT_SEEDS: SolAuthority = 'EXPORT_SEEDS';
  public static readonly EXPORT_TRACKER: SolAuthority = 'EXPORT_TRACKER';
  public static readonly EXPORT_WEBSITES: SolAuthority = 'EXPORT_WEBSITES';
  public static readonly EXPOSED_ACCOUNT_PASSWORD_VIEW: SolAuthority = 'EXPOSED_ACCOUNT_PASSWORD_VIEW';
  public static readonly EXPOSED_ACCOUNT_CHANGE_STATUS: SolAuthority = 'EXPOSED_ACCOUNT_CHANGE_STATUS';
  public static readonly EXPOSED_ACCOUNT_CHANGE_PLATFORM: SolAuthority = 'EXPOSED_ACCOUNT_CHANGE_PLATFORM';
  public static readonly EXPOSED_ACCOUNT_EXPORT: SolAuthority = 'EXPOSED_ACCOUNT_EXPORT';
  public static readonly EXPOSED_ACCOUNT_REPROCESS: SolAuthority = 'EXPOSED_ACCOUNT_REPROCESS';
  public static readonly EXPOSED_ACCOUNT_TAG_ADD: SolAuthority = 'EXPOSED_ACCOUNT_TAG_ADD';
  public static readonly EXPOSED_ACCOUNT_TAG_DELETE: SolAuthority = 'EXPOSED_ACCOUNT_TAG_DELETE';
  public static readonly EXPOSED_ACCOUNT_INSTANT_NOTIFICATION: SolAuthority = 'EXPOSED_ACCOUNT_INSTANT_NOTIFICATION';
  public static readonly EXPOSURE_ARTIFACT_CHANGE_STATUS: SolAuthority = 'EXPOSURE_ARTIFACT_CHANGE_STATUS';
  public static readonly EXPOSURE_ARTIFACT_EXPORT: SolAuthority = 'EXPOSURE_ARTIFACT_EXPORT';
  public static readonly EXPOSURE_ARTIFACT_REPROCESS: SolAuthority = 'EXPOSURE_ARTIFACT_REPROCESS';
  public static readonly EXPOSURE_ARTIFACT_TAG_ADD: SolAuthority = 'EXPOSURE_ARTIFACT_TAG_ADD';
  public static readonly EXPOSURE_ARTIFACT_TAG_DELETE: SolAuthority = 'EXPOSURE_ARTIFACT_TAG_DELETE';
  public static readonly EXPOSURE_ARTIFACT_INSTANT_NOTIFICATION: SolAuthority =
    'EXPOSURE_ARTIFACT_INSTANT_NOTIFICATION';
  public static readonly EXPOSURE_ARTIFACT_DOWNLOAD: SolAuthority = 'EXPOSURE_ARTIFACT_DOWNLOAD';
  public static readonly EXPOSED_COOKIE_CHANGE_STATUS: SolAuthority = 'EXPOSED_COOKIE_CHANGE_STATUS';
  public static readonly EXPOSED_COOKIE_CHANGE_PLATFORM: SolAuthority = 'EXPOSED_COOKIE_CHANGE_PLATFORM';
  public static readonly EXPOSED_COOKIE_TAG_ADD: SolAuthority = 'EXPOSED_COOKIE_TAG_ADD';
  public static readonly EXPOSED_COOKIE_TAG_DELETE: SolAuthority = 'EXPOSED_COOKIE_TAG_DELETE';
  public static readonly EXPOSED_COOKIE_REPROCESS: SolAuthority = 'EXPOSED_COOKIE_REPROCESS';
  public static readonly EXPOSED_COOKIE_INSTANT_NOTIFICATION: SolAuthority = 'EXPOSED_COOKIE_INSTANT_NOTIFICATION';
  public static readonly EXPOSED_COOKIE_EXPORT: SolAuthority = 'EXPOSED_COOKIE_EXPORT';
  public static readonly GENERATE_SCOPE_REPORTS: SolAuthority = 'GENERATE_SCOPE_REPORTS';
  public static readonly LINK_INTEGRATION_TRACKER: SolAuthority = 'LINK_INTEGRATION_TRACKER';
  public static readonly LIST_AUDIT_LOGS: SolAuthority = 'LIST_AUDIT_LOGS';
  public static readonly LIST_CERTIFICATES: SolAuthority = 'LIST_CERTIFICATES';
  public static readonly LIST_DARK_WEB: SolAuthority = 'LIST_DARK_WEB';
  public static readonly LIST_DATA_LEAKAGE: SolAuthority = 'LIST_DATA_LEAKAGE';
  public static readonly LIST_DOMAINS: SolAuthority = 'LIST_DOMAINS';
  public static readonly LIST_DOMAIN_IDENTIFICATION: SolAuthority = 'LIST_DOMAIN_IDENTIFICATION';
  public static readonly LIST_HOSTS: SolAuthority = 'LIST_HOSTS';
  public static readonly LIST_HOST_PORT_INFO: SolAuthority = 'LIST_HOST_PORT_INFO';
  public static readonly LIST_HOST_SCAN_HISTORY: SolAuthority = 'LIST_HOST_SCAN_HISTORY';
  public static readonly LIST_INTEGRATIONS: SolAuthority = 'LIST_INTEGRATIONS';
  public static readonly LIST_LEAKED_CREDENTIALS: SolAuthority = 'LIST_LEAKED_CREDENTIALS';
  public static readonly LIST_MANUAL_SCANS: SolAuthority = 'LIST_MANUAL_SCANS';
  public static readonly LIST_MOBILE: SolAuthority = 'LIST_MOBILE';
  public static readonly LIST_OBSERVATIONS: SolAuthority = 'LIST_OBSERVATIONS';
  public static readonly LIST_SOCIAL_MEDIA: SolAuthority = 'LIST_SOCIAL_MEDIA';
  public static readonly LIST_VULNERABILITIES: SolAuthority = 'LIST_VULNERABILITIES';
  public static readonly LIST_VULNERABILITIES_TRENDING: SolAuthority = 'LIST_VULNERABILITIES_TRENDING';
  public static readonly LIST_WEBSITES: SolAuthority = 'LIST_WEBSITES';
  public static readonly MANAGE_API_TOKENS: SolAuthority = 'MANAGE_API_TOKENS';
  public static readonly MANAGE_SCOPES: SolAuthority = 'MANAGE_SCOPES';
  public static readonly MANUAL_INSTANT_NOTIFICATION_DARK_WEB: SolAuthority = 'MANUAL_INSTANT_NOTIFICATION_DARK_WEB';
  public static readonly MANUAL_INSTANT_NOTIFICATION_DATA_LEAKAGE: SolAuthority =
    'MANUAL_INSTANT_NOTIFICATION_DATA_LEAKAGE';
  public static readonly MANUAL_INSTANT_NOTIFICATION_MOBILE: SolAuthority = 'MANUAL_INSTANT_NOTIFICATION_MOBILE';
  public static readonly MANUAL_INSTANT_NOTIFICATION_SOCIAL_MEDIA: SolAuthority =
    'MANUAL_INSTANT_NOTIFICATION_SOCIAL_MEDIA';
  public static readonly MANUAL_SCAN_DOMAINS: SolAuthority = 'MANUAL_SCAN_DOMAINS';
  public static readonly MANUAL_SCAN_WEBSITES: SolAuthority = 'MANUAL_SCAN_WEBSITES';
  public static readonly MONITOR_FROM_DOMAIN_IDENTIFICATION: SolAuthority = 'MONITOR_FROM_DOMAIN_IDENTIFICATION';
  public static readonly MULTI_ANNOTATION_DARK_WEB: SolAuthority = 'MULTI_ANNOTATION_DARK_WEB';
  public static readonly MULTI_ANNOTATION_DATA_LEAKAGE: SolAuthority = 'MULTI_ANNOTATION_DATA_LEAKAGE';
  public static readonly MULTI_ANNOTATION_DOMAINS: SolAuthority = 'MULTI_ANNOTATION_DOMAINS';
  public static readonly MULTI_ANNOTATION_LEAKED_CREDENTIALS: SolAuthority = 'MULTI_ANNOTATION_LEAKED_CREDENTIALS';
  public static readonly MULTI_ANNOTATION_MOBILE: SolAuthority = 'MULTI_ANNOTATION_MOBILE';
  public static readonly MULTI_ANNOTATION_SOCIAL_MEDIA: SolAuthority = 'MULTI_ANNOTATION_SOCIAL_MEDIA';
  public static readonly MULTI_ANNOTATION_TRACKER: SolAuthority = 'MULTI_ANNOTATION_TRACKER';
  public static readonly MULTI_TAG_DARK_WEB: SolAuthority = 'MULTI_TAG_DARK_WEB';
  public static readonly MULTI_TAG_DATA_LEAKAGE: SolAuthority = 'MULTI_TAG_DATA_LEAKAGE';
  public static readonly MULTI_TAG_DOMAINS: SolAuthority = 'MULTI_TAG_DOMAINS';
  public static readonly MULTI_TAG_DOMAIN_IDENTIFICATION: SolAuthority = 'MULTI_TAG_DOMAIN_IDENTIFICATION';
  public static readonly MULTI_TAG_HOSTS: SolAuthority = 'MULTI_TAG_HOSTS';
  public static readonly MULTI_TAG_LEAKED_CREDENTIALS: SolAuthority = 'MULTI_TAG_LEAKED_CREDENTIALS';
  public static readonly MULTI_TAG_MOBILE: SolAuthority = 'MULTI_TAG_MOBILE';
  public static readonly MULTI_TAG_SOCIAL_MEDIA: SolAuthority = 'MULTI_TAG_SOCIAL_MEDIA';
  public static readonly MULTI_TAG_TRACKER: SolAuthority = 'MULTI_TAG_TRACKER';
  public static readonly MULTI_TAG_WEBSITES: SolAuthority = 'MULTI_TAG_WEBSITES';
  public static readonly MUTE_TRACKER: SolAuthority = 'MUTE_TRACKER';
  public static readonly OVERRIDE_SUBSCOPE_DARK_WEB: SolAuthority = 'OVERRIDE_SUBSCOPE_DARK_WEB';
  public static readonly OVERRIDE_SUBSCOPE_DATA_LEAKAGE: SolAuthority = 'OVERRIDE_SUBSCOPE_DATA_LEAKAGE';
  public static readonly OVERRIDE_SUBSCOPE_MOBILE: SolAuthority = 'OVERRIDE_SUBSCOPE_MOBILE';
  public static readonly OVERRIDE_SUBSCOPE_SOCIAL_MEDIA: SolAuthority = 'OVERRIDE_SUBSCOPE_SOCIAL_MEDIA';
  public static readonly REPROCESS_DARK_WEB: SolAuthority = 'REPROCESS_DARK_WEB';
  public static readonly REPROCESS_DATA_LEAKAGE: SolAuthority = 'REPROCESS_DATA_LEAKAGE';
  public static readonly REPROCESS_LEAKED_CREDENTIAL: SolAuthority = 'REPROCESS_LEAKED_CREDENTIAL';
  public static readonly REPROCESS_MOBILE: SolAuthority = 'REPROCESS_MOBILE';
  public static readonly REPROCESS_SOCIAL_MEDIA: SolAuthority = 'REPROCESS_SOCIAL_MEDIA';
  public static readonly REQUEST_ACTIVE_SCAN: SolAuthority = 'REQUEST_ACTIVE_SCAN';
  public static readonly SAVE_SEARCHES: SolAuthority = 'SAVE_SEARCHES';
  public static readonly TRIGGER_NOTIFICATIONS: SolAuthority = 'TRIGGER_NOTIFICATIONS';
  public static readonly UNDISMISS_DOMAINS: SolAuthority = 'UNDISMISS_DOMAINS';
  public static readonly UNDISMISS_HOSTS: SolAuthority = 'UNDISMISS_HOSTS';
  public static readonly UNLINK_SEED: SolAuthority = 'UNLINK_SEED';
  public static readonly UPDATE_AUTOMATION_RULE_ORDER: SolAuthority = 'UPDATE_AUTOMATION_RULE_ORDER';
  public static readonly UPDATE_INTEGRATION: SolAuthority = 'UPDATE_INTEGRATION';
  public static readonly UPDATE_SCOPE_INDUSTRY: SolAuthority = 'UPDATE_SCOPE_INDUSTRY';
  public static readonly UPDATE_SCOPE_NAME: SolAuthority = 'UPDATE_SCOPE_NAME';
  public static readonly VIEW_ACTIVE_SCAN_STATUS: SolAuthority = 'VIEW_ACTIVE_SCAN_STATUS';
  public static readonly VIEW_ATP: SolAuthority = 'VIEW_ATP';
  public static readonly VIEW_ANNOUNCEMENTS: SolAuthority = 'VIEW_ANNOUNCEMENTS';
  public static readonly VIEW_AUTOMATION_RULES: SolAuthority = 'VIEW_AUTOMATION_RULES';
  public static readonly VIEW_BENCHMARKS: SolAuthority = 'VIEW_BENCHMARKS';
  public static readonly VIEW_CERTIFICATE_DETAILS: SolAuthority = 'VIEW_CERTIFICATE_DETAILS';
  public static readonly VIEW_DARK_WEB_DETAILS: SolAuthority = 'VIEW_DARK_WEB_DETAILS';
  public static readonly VIEW_DATA_LEAKAGE_DETAILS: SolAuthority = 'VIEW_DATA_LEAKAGE_DETAILS';
  public static readonly VIEW_DOMAIN_DETAILS: SolAuthority = 'VIEW_DOMAIN_DETAILS';
  public static readonly VIEW_DOMAIN_IDENTIFICATION_DETAILS: SolAuthority = 'VIEW_DOMAIN_IDENTIFICATION_DETAILS';
  public static readonly VIEW_HOST_DETAILS: SolAuthority = 'VIEW_HOST_DETAILS';
  public static readonly VIEW_HUBSPOT: SolAuthority = 'VIEW_HUBSPOT';
  public static readonly VIEW_LEAKED_CREDENTIAL_DETAILS: SolAuthority = 'VIEW_LEAKED_CREDENTIAL_DETAILS';
  public static readonly VIEW_LEAKED_CREDENTIAL_PASSWORD: SolAuthority = 'VIEW_LEAKED_CREDENTIAL_PASSWORD';
  public static readonly VIEW_MOBILE_DETAILS: SolAuthority = 'VIEW_MOBILE_DETAILS';
  public static readonly VIEW_MODULES: SolAuthority = 'VIEW_MODULES';
  public static readonly VIEW_NETWORK: SolAuthority = 'VIEW_NETWORK';
  public static readonly VIEW_NOTIFICATION_ALERT_TYPES: SolAuthority = 'VIEW_NOTIFICATION_ALERT_TYPES';
  public static readonly VIEW_NOTIFICATION_RULES: SolAuthority = 'VIEW_NOTIFICATION_RULES';
  public static readonly VIEW_OBSERVATION_DETAILS: SolAuthority = 'VIEW_OBSERVATION_DETAILS';
  public static readonly VIEW_PARTNER_WIKI_DOCS: SolAuthority = 'VIEW_PARTNER_WIKI_DOCS';
  public static readonly VIEW_PERMISSIONS: SolAuthority = 'VIEW_PERMISSIONS';
  public static readonly VIEW_ROLES: SolAuthority = 'VIEW_ROLES';
  public static readonly VIEW_SAVED_SEARCHES: SolAuthority = 'VIEW_SAVED_SEARCHES';
  public static readonly VIEW_SCOPES: SolAuthority = 'VIEW_SCOPES';
  public static readonly VIEW_SCOPE_DETAILS: SolAuthority = 'VIEW_SCOPE_DETAILS';
  public static readonly VIEW_SCOPE_REPORTS: SolAuthority = 'VIEW_SCOPE_REPORTS';
  public static readonly VIEW_SCOPE_STATS: SolAuthority = 'VIEW_SCOPE_STATS';
  public static readonly VIEW_SEEDS: SolAuthority = 'VIEW_SEEDS';
  public static readonly VIEW_SOCIAL_MEDIA_DETAILS: SolAuthority = 'VIEW_SOCIAL_MEDIA_DETAILS';
  public static readonly VIEW_SUBSCOPES: SolAuthority = 'VIEW_SUBSCOPES';
  public static readonly VIEW_TAGS: SolAuthority = 'VIEW_TAGS';
  public static readonly VIEW_TECHNOLOGIES: SolAuthority = 'VIEW_TECHNOLOGIES';
  public static readonly VIEW_USERS: SolAuthority = 'VIEW_USERS';
  public static readonly VIEW_USER_ROLES: SolAuthority = 'VIEW_USER_ROLES';
  public static readonly VIEW_USER_WIKI_DOCS: SolAuthority = 'VIEW_USER_WIKI_DOCS';
  public static readonly VIEW_VULNERABILITY_DETAILS: SolAuthority = 'VIEW_VULNERABILITY_DETAILS';
  public static readonly VIEW_VULNERABILITY_MENTIONS: SolAuthority = 'VIEW_VULNERABILITY_MENTIONS';
  public static readonly VIEW_WEBSITE_DETAILS: SolAuthority = 'VIEW_WEBSITE_DETAILS';
  public static readonly VIEW_WHATS_NEW: SolAuthority = 'VIEW_WHATS_NEW';
  public static readonly VIEW_DOWNLOADS: SolAuthority = 'VIEW_DOWNLOADS';
  public static readonly VIEW_ENGAGEMENT_REQUESTS: SolAuthority = 'VIEW_ENGAGEMENT_REQUESTS';
  public static readonly VIEW_OBSERVATION_COMMENTS: SolAuthority = 'VIEW_OBSERVATION_COMMENTS';
  public static readonly REQUEST_OBSERVATION_VERIFICATION: SolAuthority = 'REQUEST_OBSERVATION_VERIFICATION';
  public static readonly CREATE_ENGAGEMENT_REQUEST: SolAuthority = 'CREATE_ENGAGEMENT_REQUEST';
  public static readonly EDIT_ENGAGEMENT_REQUEST: SolAuthority = 'EDIT_ENGAGEMENT_REQUEST';
  public static readonly VIEW_PLATFORM_REPORTS: SolAuthority = 'VIEW_PLATFORM_REPORTS';
  public static readonly MANAGE_PLATFORM_REPORTS: SolAuthority = 'MANAGE_PLATFORM_REPORTS';

  //
  // Partner
  //
  public static readonly VIEW_PARTNER_APP: SolAuthority = 'VIEW_PARTNER_APP';
  public static readonly VIEW_PARTNER_SCOPES: SolAuthority = 'VIEW_PARTNER_SCOPES';
  public static readonly EDIT_PARTNER_SCOPES: SolAuthority = 'EDIT_PARTNER_SCOPES';
  public static readonly VIEW_PARTNER_USERS: SolAuthority = 'VIEW_PARTNER_USERS';
  public static readonly EDIT_PARTNER_USERS: SolAuthority = 'EDIT_PARTNER_USERS';
  public static readonly VIEW_PARTNER_ROLES: SolAuthority = 'VIEW_PARTNER_ROLES';
  public static readonly EDIT_PARTNER_ROLES: SolAuthority = 'EDIT_PARTNER_ROLES';
  public static readonly VIEW_PARTNER_SCOPE_USERS: SolAuthority = 'VIEW_PARTNER_SCOPE_USERS';
  public static readonly EDIT_PARTNER_SCOPE_USERS: SolAuthority = 'EDIT_PARTNER_SCOPE_USERS';
  public static readonly VIEW_PARTNER_SCOPE_ROLES: SolAuthority = 'VIEW_PARTNER_SCOPE_ROLES';
  public static readonly EDIT_PARTNER_SCOPE_ROLES: SolAuthority = 'EDIT_PARTNER_SCOPE_ROLES';
  public static readonly VIEW_PARTNER_API: SolAuthority = 'VIEW_PARTNER_API';
  public static readonly EDIT_PARTNER_API: SolAuthority = 'EDIT_PARTNER_API';
  public static readonly VIEW_PARTNER_INTEGRATIONS: SolAuthority = 'VIEW_PARTNER_INTEGRATIONS';
  public static readonly EDIT_PARTNER_INTEGRATIONS: SolAuthority = 'EDIT_PARTNER_INTEGRATIONS';
  public static readonly VIEW_PARTNER_AUDIT_LOGS: SolAuthority = 'VIEW_PARTNER_AUDIT_LOGS';
  public static readonly VIEW_PARTNER_BILLING: SolAuthority = 'VIEW_PARTNER_BILLING';
  public static readonly MANAGE_PARTNER_SETTINGS: SolAuthority = 'MANAGE_PARTNER_SETTINGS';
  public static readonly MANAGE_SCOPE_SETTINGS: SolAuthority = 'MANAGE_SCOPE_SETTINGS';
  public static readonly VIEW_BILLING: SolAuthority = 'VIEW_BILLING';
  public static readonly ALLOW_PLATFORM_ACCESS: SolAuthority = 'ALLOW_PLATFORM_ACCESS';
  public static readonly ALLOW_PLATFORM_ACCESS_WITHOUT_REASON: SolAuthority = 'ALLOW_PLATFORM_ACCESS_WITHOUT_REASON';

  //
  // Admin
  //
  public static readonly VIEW_ADMIN_APP: SolAuthority = 'VIEW_ADMIN_APP';
  public static readonly VIEW_ADMIN_PARTNERS: SolAuthority = 'VIEW_ADMIN_PARTNERS';
  public static readonly EDIT_ADMIN_PARTNERS: SolAuthority = 'EDIT_ADMIN_PARTNERS';
  public static readonly VIEW_ADMIN_USERS: SolAuthority = 'VIEW_ADMIN_USERS';
  public static readonly EDIT_ADMIN_USERS: SolAuthority = 'EDIT_ADMIN_USERS';
  public static readonly VIEW_ADMIN_ROLES: SolAuthority = 'VIEW_ADMIN_ROLES';
  public static readonly EDIT_ADMIN_ROLES: SolAuthority = 'EDIT_ADMIN_ROLES';
  public static readonly VIEW_ADMIN_API: SolAuthority = 'VIEW_ADMIN_API';
  public static readonly EDIT_ADMIN_API: SolAuthority = 'EDIT_ADMIN_API';
  public static readonly VIEW_ADMIN_LICENSING: SolAuthority = 'VIEW_ADMIN_LICENSING';
  public static readonly EDIT_ADMIN_LICENSING: SolAuthority = 'EDIT_ADMIN_LICENSING';
  public static readonly VIEW_ADMIN_INTERNAL_TASKS: SolAuthority = 'VIEW_ADMIN_INTERNAL_TASKS';
  public static readonly EDIT_ADMIN_INTERNAL_TASKS: SolAuthority = 'EDIT_ADMIN_INTERNAL_TASKS';
  public static readonly VIEW_ADMIN_DRP_SOURCES: SolAuthority = 'VIEW_ADMIN_DRP_SOURCES';
  public static readonly EDIT_ADMIN_DRP_SOURCES: SolAuthority = 'EDIT_ADMIN_DRP_SOURCES';

  // Admin dashboards
  public static readonly VIEW_ADMIN_DASHBOARDS: SolAuthority = 'VIEW_ADMIN_DASHBOARDS';
  public static readonly EDIT_ADMIN_DASHBOARDS: SolAuthority = 'EDIT_ADMIN_DASHBOARDS';
  public static readonly MANAGE_ADMIN_DASHBOARDS: SolAuthority = 'MANAGE_ADMIN_DASHBOARDS';

  // Admin dashboard definitions
  public static readonly MANAGE_DASHBOARD_DEFINITIONS: SolAuthority = 'MANAGE_DASHBOARD_DEFINITIONS';

  // Admin platform settings
  public static readonly MANAGE_GLOBAL_SETTINGS: SolAuthority = 'MANAGE_GLOBAL_SETTINGS';

  // Admin banners
  public static readonly EDIT_ADMIN_BANNERS: SolAuthority = 'EDIT_ADMIN_BANNERS';

  //
  // Sol catalog
  //
  public static readonly VIEW_SOL_CATALOG_APP: SolAuthority = 'VIEW_SOL_CATALOG_APP';

  //
  // ASM Prototype
  //
  public static readonly VIEW_ASM_PROTOTYPE_APP: SolAuthority = 'VIEW_ASM_PROTOTYPE_APP';
}
